const createObserver = (callback = () => {}, options = {}) => {
   return new IntersectionObserver(callback, {threshold: 1.0, ...options});
}

export default createObserver;
